module.exports = __webpack_public_path__ + "img/李建庆.f8e24524.jpg";